import { PageType } from "@product/scmp-sdk";

export const pathname = "/plus/learnmore";

export const page = {
  route(query: QueryParameters) {
    return { pathname, query: { ...query, pageType: PageType.Plus } };
  },
};
